import { Box } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { ConversationMeta } from '../../shared/types'
import ConversationList from './ConversationList'
import Section from './Section'

export interface ConversationSidebarProps {
  items: ConversationMeta[]
  activeId?: string
  onSelect: (id: string) => void
  onRename?: (id: string, title: string) => void
  onShare?: (id: string) => void
  onDelete?: (id: string) => void
}

const isSharedWithMe = (c: ConversationMeta): boolean =>
  c.access === 'viewer' || c.access === 'editor'

export default function ConversationSidebar(props: ConversationSidebarProps) {
  const intl = useIntl()
  const { items, activeId, onSelect, onRename, onShare, onDelete } = props
  const owned = items.filter((c) => !isSharedWithMe(c))
  const shared = items.filter(isSharedWithMe)

  return (
    <Box>
      <Section title={intl.formatMessage({ id: 'caChat.sidebar.section.mine' })} count={owned.length} defaultOpen={true}>
        <ConversationList
          items={owned}
          activeId={activeId}
          onSelect={onSelect}
          onRename={onRename}
          onShare={onShare}
          onDelete={onDelete}
          emptyText={intl.formatMessage({ id: 'caChat.sidebar.empty.mine' })}
        />
      </Section>

      {shared.length > 0 && (
        <Section title={intl.formatMessage({ id: 'caChat.sidebar.section.shared' })} count={shared.length} defaultOpen={true}>
          <ConversationList items={shared} activeId={activeId} onSelect={onSelect} />
        </Section>
      )}
    </Box>
  )
}
